import { Box, Typography } from "@mui/material";
import SvgToIcon from "../../icons/SvgToIcon";
export const EmptyState = ({ icon, title, description, smallText = false }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "32px",
      }}
    >
      <SvgToIcon IconLogo={icon} width="80px" height="80px" />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
        }}
      >
        <Typography variant="h6">{title}</Typography>
        <Typography
          variant={smallText ? "body2" : "body1"}
          sx={{ whiteSpace: "pre-line", textAlign: "center" }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
};
